import { createAction, props } from '@ngrx/store';

import { Quicklink } from './newsfeed-quicklinks.models';

import { TopTag } from '../../service/newsfeed-api-response.models';

export const loadQuicklinks = createAction('[Newsfeed/API] Load newsfeed quicklinks');

export const loadTopTagsSuccess = createAction('[Newsfeed/API] Load top tags success', props<{ topTags: TopTag[] }>());

export const loadTopTagsFailure = createAction('[Newsfeed/API] Load top tags failure', props<{ error: string }>());

export const loadQuicklinksSuccess = createAction(
  '[Newsfeed/API] Load quicklinks success',
  props<{ quicklinks: Quicklink[] }>()
);

export const loadQuicklinksFailure = createAction('[Newsfeed/API] Load quicklinks failure', props<{ error: string }>());
